var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "post post-facebook post-linkedin",
      class: { "response-comment": _vm.responseComment },
    },
    [
      _c(
        "div",
        {
          staticClass: "detail-event-header",
          class: {
            "no-border":
              (_vm.post &&
                Object.keys(_vm.post).length &&
                !_vm.post.commentary) ||
              _vm.isLoading,
          },
        },
        [
          _vm.currentPage
            ? _c("AvatarComponent", {
                attrs: {
                  typeNetwork: _vm.currentPage.network,
                  urlPicture: _vm.currentPage.avatar,
                },
              })
            : _vm._e(),
          _c("div", { staticClass: "info" }, [
            _vm.currentPage
              ? _c(
                  "div",
                  {
                    staticClass: "namePage",
                    on: { click: _vm.scrollToOriginalComment },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.currentPage.name) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "typeEvent" },
              [
                _c("p", { attrs: { html: "" } }, [
                  _vm._v(_vm._s(_vm.dateFormatPost(_vm.event.date * 1000))),
                ]),
                _vm.event.data && _vm.event.data.generatedActivity
                  ? [
                      _vm.event.type == "comment"
                        ? _c("p", { staticClass: "show-post" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `https://www.linkedin.com/feed/update/${
                                    _vm.event.data.sourcePost
                                  }?commentUrn=${encodeURIComponent(
                                    _vm.event.data.generatedActivity
                                  )}`,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("Voir")]
                            ),
                          ])
                        : _c("p", { staticClass: "show-post" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `https://www.linkedin.com/feed/update/${_vm.event.data.sourcePost}`,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("Voir")]
                            ),
                          ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _c(
            "div",
            { staticClass: "selectActionEvent" },
            [
              _c("SelectComponent", {
                attrs: {
                  id: _vm.event._id,
                  changeValueSelect: _vm.changeStatus,
                  data: {
                    treated: _vm.$t("dash.inbox.state.treated"),
                    waiting: _vm.$t("dash.inbox.state.waiting"),
                  },
                  valueSelect: [1, 3].includes(_vm.event.status)
                    ? "treated"
                    : "waiting",
                  positionY: "bottom",
                  positionAuto: false,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "scrollable" },
        [
          _vm.post == false
            ? [_vm._m(0)]
            : _vm.isLoading || !_vm.post || !Object.keys(_vm.post).length
            ? [
                _c(
                  "div",
                  { staticClass: "container-content-post loading-content" },
                  [
                    _c("div", { staticClass: "content-post" }, [
                      _vm._m(1),
                      _c("div", { staticClass: "post-footer" }, [
                        _vm._m(2),
                        _c("div", { staticClass: "bottom" }, [
                          _c("div", { staticClass: "like" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "auto",
                                  width: "auto",
                                  viewBox: "0 0 24 24",
                                  "aria-hidden": "true",
                                  role: "none",
                                  "data-supported-dps": "24x24",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M19.46 11l-3.91-3.91a7 7 0 01-1.69-2.74l-.49-1.47A2.76 2.76 0 0010.76 1 2.75 2.75 0 008 3.74v1.12a9.19 9.19 0 00.46 2.85L8.89 9H4.12A2.12 2.12 0 002 11.12a2.16 2.16 0 00.92 1.76A2.11 2.11 0 002 14.62a2.14 2.14 0 001.28 2 2 2 0 00-.28 1 2.12 2.12 0 002 2.12v.14A2.12 2.12 0 007.12 22h7.49a8.08 8.08 0 003.58-.84l.31-.16H21V11zM19 19h-1l-.73.37a6.14 6.14 0 01-2.69.63H7.72a1 1 0 01-1-.72l-.25-.87-.85-.41A1 1 0 015 17l.17-1-.76-.74A1 1 0 014.27 14l.66-1.09-.73-1.1a.49.49 0 01.08-.7.48.48 0 01.34-.11h7.05l-1.31-3.92A7 7 0 0110 4.86V3.75a.77.77 0 01.75-.75.75.75 0 01.71.51L12 5a9 9 0 002.13 3.5l4.5 4.5H19z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                                J'aime\n                            "
                            ),
                          ]),
                          _c("div", { staticClass: "comments" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "auto",
                                  width: "auto",
                                  viewBox: "0 0 24 24",
                                  "aria-hidden": "true",
                                  role: "none",
                                  "data-supported-dps": "24x24",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M7 9h10v1H7zm0 4h7v-1H7zm16-2a6.78 6.78 0 01-2.84 5.61L12 22v-4H8A7 7 0 018 4h8a7 7 0 017 7zm-2 0a5 5 0 00-5-5H8a5 5 0 000 10h6v2.28L19 15a4.79 4.79 0 002-4z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                                Commenter\n                            "
                            ),
                          ]),
                          _c("div", { staticClass: "share" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "auto",
                                  width: "auto",
                                  viewBox: "0 0 24 24",
                                  "aria-hidden": "true",
                                  role: "none",
                                  "data-supported-dps": "24x24",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M13.96 5H6c-.55 0-1 .45-1 1v10H3V6c0-1.66 1.34-3 3-3h7.96L12 0h2.37L17 4l-2.63 4H12l1.96-3zm5.54 3H19v10c0 .55-.45 1-1 1h-7.96L12 16H9.63L7 20l2.63 4H12l-1.96-3H18c1.66 0 3-1.34 3-3V8h-1.5z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                                Republier\n                            "
                            ),
                          ]),
                          _c("div", { staticClass: "send" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "auto",
                                  width: "auto",
                                  viewBox: "0 0 24 24",
                                  "aria-hidden": "true",
                                  role: "none",
                                  "data-supported-dps": "24x24",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M21 3L0 10l7.66 4.26L16 8l-6.26 8.34L14 24l7-21z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                                Envoyer\n                            "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "container-content-comments loading-content" },
                  _vm._l(3, function (index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "container-comment" },
                      [
                        _c("div", { staticClass: "comment" }, [
                          _vm._m(3, true),
                          _c("div", { staticClass: "container-content" }, [
                            _c("div", { staticClass: "content" }, [
                              _c("p", { staticClass: "name-user" }, [
                                _vm._v("www"),
                              ]),
                              _c("p", { staticClass: "text" }, [
                                _vm._v(
                                  _vm._s("w".repeat(5 + Math.random() * 10))
                                ),
                              ]),
                            ]),
                            _vm._m(4, true),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : _vm.post && Object.keys(_vm.post).length
            ? [
                _c("div", { staticClass: "container-content-post" }, [
                  _c("div", { staticClass: "content-post" }, [
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _vm.post.commentary ||
                        (_vm.event.type == "mention" &&
                          _vm.post.text &&
                          _vm.post.text.text)
                          ? _c("div", { staticClass: "text" }, [
                              _c("pre", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.messagePostFormat(
                                      _vm.event.type == "mention" &&
                                        _vm.post.text &&
                                        _vm.post.text.text
                                        ? _vm.post.text.text
                                        : _vm.post.commentary
                                    )
                                  ),
                                },
                              }),
                            ])
                          : _vm._e(),
                        _vm.post.content && _vm.post.content.article
                          ? _c(
                              "a",
                              {
                                staticClass: "link",
                                attrs: {
                                  href: _vm.post.content.article.source,
                                  target: "_blank",
                                },
                              },
                              [
                                _vm.post.content.article.thumbnail
                                  ? _c("div", { staticClass: "banner-link" }, [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.post.content.article
                                            .thumbnail.downloadUrl,
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "footer-link" }, [
                                  _c(
                                    "p",
                                    { staticClass: "footer-link-domaine" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.getHostname(
                                              _vm.post.content.article.source
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "footer-link-title" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.post.content.article.title
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "footer-link-description" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.post.content.article.description
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm.post.content &&
                        _vm.post.content.media &&
                        _vm.post.content.media.image
                          ? [
                              _vm.post.content.media.image.downloadUrl
                                ? [
                                    _vm.post.content.media.id.includes(
                                      "urn:li:image:"
                                    )
                                      ? _c("div", { staticClass: "picture" }, [
                                          _c("img", {
                                            attrs: {
                                              src: _vm.post.content.media.image
                                                .downloadUrl,
                                            },
                                          }),
                                        ])
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm.post.content && _vm.post.content.multiImage
                          ? [
                              _c(
                                "div",
                                {
                                  class:
                                    "post-medias media" +
                                    Math.min(
                                      _vm.post.content.multiImage.length,
                                      4
                                    ),
                                },
                                _vm._l(
                                  _vm.post.content.multiImage.slice(0, 4),
                                  function (media, i) {
                                    return _c(
                                      "div",
                                      { key: i, staticClass: "media" },
                                      [
                                        i == 3 &&
                                        _vm.post.content.multiImage.length > 4
                                          ? _c(
                                              "div",
                                              { staticClass: "count" },
                                              [
                                                _vm._v(
                                                  "+" +
                                                    _vm._s(
                                                      Math.min(
                                                        _vm.post.content
                                                          .multiImage.length,
                                                        20
                                                      ) - 3
                                                    )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("img", {
                                          attrs: {
                                            src: media.downloadUrl,
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          : _vm._e(),
                        _vm.post.content &&
                        _vm.post.content.media &&
                        _vm.post.content.media.video
                          ? [
                              _vm.post.content.media.video.downloadUrl
                                ? [
                                    _vm.post.content.media.id.includes(
                                      "urn:li:video:"
                                    )
                                      ? _c("div", { staticClass: "video" }, [
                                          _c("video", {
                                            attrs: {
                                              controls: "",
                                              src: _vm.post.content.media.video
                                                .downloadUrl,
                                            },
                                          }),
                                        ])
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm.post.content &&
                        _vm.post.content.media &&
                        _vm.post.content.media.document
                          ? [
                              _vm.post.content.media.document.downloadUrl
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "pdf-viewer" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "navigation-bar" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.post.content.media.title
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("span", [_vm._v("•")]),
                                            _vm._v(
                                              _vm._s(_vm.pdfPageNumber) +
                                                " pages\n                                    "
                                            ),
                                          ]
                                        ),
                                        _c("pdf", {
                                          attrs: {
                                            src: _vm.post.content.media.document
                                              .downloadUrl,
                                            page: _vm.pdfPage,
                                          },
                                          on: {
                                            numpages: (n) =>
                                              (_vm.pdfPageNumber = n),
                                          },
                                        }),
                                        _vm.pdfPage > 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "previous btn-nav",
                                                on: {
                                                  click: () => _vm.pdfPage--,
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-solid fa-chevron-left",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.pdfPage < _vm.pdfPageNumber
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "next btn-nav",
                                                on: {
                                                  click: () => _vm.pdfPage++,
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-solid fa-chevron-right",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "post-footer" }, [
                      _c("div", { staticClass: "top" }, [
                        _c(
                          "div",
                          { staticClass: "reactions" },
                          [
                            _vm.post &&
                            _vm.post.reactions &&
                            _vm.post.reactions.reactionSummaries
                              ? [
                                  _vm.post.reactions.reactionSummaries.MAYBE
                                    ? _c("div", { staticClass: "reaction" }, [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/linkedin-curious.png"),
                                            alt: "MAYBE",
                                          },
                                        }),
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.post.reactions
                                                .reactionSummaries.MAYBE.count
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm.post.reactions.reactionSummaries.PRAISE
                                    ? _c("div", { staticClass: "reaction" }, [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/linkedin-celebrate.png"),
                                            alt: "PRAISE",
                                          },
                                        }),
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.post.reactions
                                                .reactionSummaries.PRAISE.count
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm.post.reactions.reactionSummaries.LIKE
                                    ? _c("div", { staticClass: "reaction" }, [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/linkedin-like.png"),
                                            alt: "LIKE",
                                          },
                                        }),
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.post.reactions
                                                .reactionSummaries.LIKE.count
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm.post.reactions.reactionSummaries.EMPATHY
                                    ? _c("div", { staticClass: "reaction" }, [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/linkedin-love.png"),
                                            alt: "EMPATHY",
                                          },
                                        }),
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.post.reactions
                                                .reactionSummaries.EMPATHY.count
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm.post.reactions.reactionSummaries.INTEREST
                                    ? _c("div", { staticClass: "reaction" }, [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/linkedin-insightful.png"),
                                            alt: "INTEREST",
                                          },
                                        }),
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.post.reactions
                                                .reactionSummaries.INTEREST
                                                .count
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm.post.reactions.reactionSummaries
                                    .APPRECIATION
                                    ? _c("div", { staticClass: "reaction" }, [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../../assets/img/reporting_icons/linkedin-support.png"),
                                            alt: "APPRECIATION",
                                          },
                                        }),
                                        _c("span", { staticClass: "text" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.post.reactions
                                                .reactionSummaries.APPRECIATION
                                                .count
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm.post &&
                        _vm.post.reactions &&
                        _vm.post.reactions.commentSummary &&
                        _vm.post.reactions.commentSummary.count
                          ? _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.post.reactions.reactionSummaries.LIKE
                                    ? _vm.post.reactions.reactionSummaries.LIKE
                                        .count
                                    : 0
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.post.reactions.reactionSummaries.LIKE &&
                                      _vm.post.reactions.reactionSummaries.LIKE
                                        .count > 1
                                      ? "likes"
                                      : "like"
                                  ) +
                                  " • " +
                                  _vm._s(
                                    _vm.post.reactions.commentSummary.count
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.post.reactions.commentSummary.count > 1
                                      ? "commentaires"
                                      : "commentaire"
                                  )
                              ),
                            ])
                          : _vm.post &&
                            _vm.post.stats &&
                            _vm.post.stats.elements &&
                            _vm.post.stats.elements.length
                          ? _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.post.stats.elements[0]
                                    .totalShareStatistics.likeCount
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.post.stats.elements[0]
                                      .totalShareStatistics.likeCount > 1
                                      ? "likes"
                                      : "like"
                                  ) +
                                  " • " +
                                  _vm._s(
                                    _vm.post.stats.elements[0]
                                      .totalShareStatistics.commentCount
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.post.stats.elements[0]
                                      .totalShareStatistics.commentCount > 1
                                      ? "commentaires"
                                      : "commentaire"
                                  ) +
                                  " • " +
                                  _vm._s(
                                    _vm.post.stats.elements[0]
                                      .totalShareStatistics.shareCount
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.post.stats.elements[0]
                                      .totalShareStatistics.shareCount > 1
                                      ? "republications"
                                      : "republication"
                                  )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "bottom" }, [
                        _c(
                          "div",
                          {
                            staticClass: "like",
                            class: [{ liked: _vm.liked }],
                            on: {
                              click: function ($event) {
                                return _vm.toggleLikePost(_vm.post.id)
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "auto",
                                  width: "auto",
                                  viewBox: "0 0 24 24",
                                  "aria-hidden": "true",
                                  role: "none",
                                  "data-supported-dps": "24x24",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M19.46 11l-3.91-3.91a7 7 0 01-1.69-2.74l-.49-1.47A2.76 2.76 0 0010.76 1 2.75 2.75 0 008 3.74v1.12a9.19 9.19 0 00.46 2.85L8.89 9H4.12A2.12 2.12 0 002 11.12a2.16 2.16 0 00.92 1.76A2.11 2.11 0 002 14.62a2.14 2.14 0 001.28 2 2 2 0 00-.28 1 2.12 2.12 0 002 2.12v.14A2.12 2.12 0 007.12 22h7.49a8.08 8.08 0 003.58-.84l.31-.16H21V11zM19 19h-1l-.73.37a6.14 6.14 0 01-2.69.63H7.72a1 1 0 01-1-.72l-.25-.87-.85-.41A1 1 0 015 17l.17-1-.76-.74A1 1 0 014.27 14l.66-1.09-.73-1.1a.49.49 0 01.08-.7.48.48 0 01.34-.11h7.05l-1.31-3.92A7 7 0 0110 4.86V3.75a.77.77 0 01.75-.75.75.75 0 01.71.51L12 5a9 9 0 002.13 3.5l4.5 4.5H19z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                                J'aime\n                            "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "comments",
                            on: {
                              click: function ($event) {
                                _vm.autoFocus = true
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "auto",
                                  width: "auto",
                                  viewBox: "0 0 24 24",
                                  "aria-hidden": "true",
                                  role: "none",
                                  "data-supported-dps": "24x24",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M7 9h10v1H7zm0 4h7v-1H7zm16-2a6.78 6.78 0 01-2.84 5.61L12 22v-4H8A7 7 0 018 4h8a7 7 0 017 7zm-2 0a5 5 0 00-5-5H8a5 5 0 000 10h6v2.28L19 15a4.79 4.79 0 002-4z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                                Commenter\n                            "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "share",
                            class: [{ shared: _vm.shared }],
                            on: {
                              click: function ($event) {
                                !_vm.shared ? _vm.reshare() : null
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  height: "auto",
                                  width: "auto",
                                  viewBox: "0 0 24 24",
                                  "aria-hidden": "true",
                                  role: "none",
                                  "data-supported-dps": "24x24",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M13.96 5H6c-.55 0-1 .45-1 1v10H3V6c0-1.66 1.34-3 3-3h7.96L12 0h2.37L17 4l-2.63 4H12l1.96-3zm5.54 3H19v10c0 .55-.45 1-1 1h-7.96L12 16H9.63L7 20l2.63 4H12l-1.96-3H18c1.66 0 3-1.34 3-3V8h-1.5z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                                Republier\n                            "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "send" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                height: "auto",
                                width: "auto",
                                viewBox: "0 0 24 24",
                                "aria-hidden": "true",
                                role: "none",
                                "data-supported-dps": "24x24",
                                fill: "currentColor",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M21 3L0 10l7.66 4.26L16 8l-6.26 8.34L14 24l7-21z",
                                },
                              }),
                            ]
                          ),
                          _vm._v(
                            "\n                                Envoyer\n                            "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    ref: "comments",
                    staticClass: "container-content-comments",
                  },
                  [
                    _vm.post.comments &&
                    _vm.post.comments.data &&
                    _vm.post.comments.data.length
                      ? _vm._l(
                          _vm.post.comments.data,
                          function (comment, indexComment) {
                            return _c(
                              "div",
                              {
                                key: comment.id,
                                staticClass: "container-comment",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    ref:
                                      _vm.event.data.generatedActivity.replace(
                                        "(activity",
                                        "(urn:li:activity"
                                      ) == comment["$URN"]
                                        ? "originalComment"
                                        : null,
                                    refInFor: true,
                                    staticClass: "comment",
                                    class: {
                                      "has-response":
                                        comment.comments &&
                                        comment.comments.data &&
                                        comment.comments.data.length,
                                      hidden: comment.is_hidden,
                                      originalComment:
                                        _vm.getConvertGeneratedActivity ==
                                        comment["$URN"],
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "picture-user" }, [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            comment.user && comment.user.logoV2
                                              ? comment.user.logoV2
                                              : "img/avatar.jpg",
                                        },
                                      }),
                                      _c("div", { staticClass: "lineStart" }),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "container-content" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "content" },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "name-user" },
                                              [
                                                _vm._v(
                                                  _vm._s(comment.user.name)
                                                ),
                                              ]
                                            ),
                                            _c("p", { staticClass: "text" }, [
                                              _vm._v(
                                                _vm._s(comment.message.text)
                                              ),
                                            ]),
                                            _c("div", { staticClass: "media" }),
                                            _c(
                                              "ContextMenu",
                                              {
                                                attrs: {
                                                  options: _vm.getOptionComment(
                                                    comment.id,
                                                    comment
                                                  ),
                                                  id: comment.id,
                                                },
                                                on: {
                                                  clickOption:
                                                    _vm.clickOptionComment,
                                                },
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "btn-more",
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "info-content" },
                                          [
                                            _c("div", { staticClass: "date" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.dateFormat(
                                                    comment.created.time
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c(
                                              "div",
                                              { staticClass: "action" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "reaction",
                                                    class: {
                                                      "have-liked":
                                                        comment.user_likes,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleLikeComment(
                                                          comment.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "J'aime " +
                                                        _vm._s(
                                                          comment.like_count
                                                            ? ` (${comment.like_count})`
                                                            : ""
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "answer",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.startResponseComment(
                                                          comment.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Répondre")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                comment.comments &&
                                comment.comments.data &&
                                comment.comments.data.length
                                  ? _vm._l(
                                      comment.comments.data,
                                      function (subComment, indexSubComment) {
                                        return _c(
                                          "div",
                                          {
                                            key: subComment.id,
                                            ref:
                                              _vm.event.data.generatedActivity.replace(
                                                "(activity",
                                                "(urn:li:activity"
                                              ) == subComment["$URN"]
                                                ? "originalComment"
                                                : null,
                                            refInFor: true,
                                            staticClass: "comment response",
                                            class: {
                                              end:
                                                comment.comment_count ==
                                                  indexSubComment + 1 ||
                                                !comment.comments.data[
                                                  indexSubComment + 1
                                                ],
                                              hidden: subComment.is_hidden,
                                              originalComment:
                                                _vm.getConvertGeneratedActivity ==
                                                subComment["$URN"],
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "jonction-line line-continuous",
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "picture-user" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      subComment.user &&
                                                      subComment.user.logoV2
                                                        ? subComment.user.logoV2
                                                        : "img/avatar.jpg",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "container-content",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "content" },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "name-user",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            subComment.user.name
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      { staticClass: "text" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            subComment.message
                                                              .text
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", {
                                                      staticClass: "media",
                                                    }),
                                                    _c(
                                                      "ContextMenu",
                                                      {
                                                        attrs: {
                                                          options:
                                                            _vm.getOptionComment(
                                                              subComment.id,
                                                              subComment
                                                            ),
                                                          id: subComment.id,
                                                        },
                                                        on: {
                                                          clickOption:
                                                            _vm.clickOptionComment,
                                                        },
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "btn-more",
                                                        }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "info-content",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "date" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.dateFormat(
                                                              subComment.created
                                                                .time
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "action" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reaction",
                                                            class: {
                                                              "have-liked":
                                                                subComment.user_likes,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.toggleLikeComment(
                                                                  subComment.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("J'aime")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "answer",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.startResponseComment(
                                                                  comment.id +
                                                                    "," +
                                                                    subComment.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("Répondre")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    )
                                  : _vm._e(),
                              ],
                              2
                            )
                          }
                        )
                      : [
                          _c("p", { staticClass: "no-comment" }, [
                            _vm._v("Aucun commentaire"),
                          ]),
                        ],
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("FormSendMessage", {
        attrs: { activeMedia: false, setAutofocus: _vm.autoFocus },
        on: {
          onSubmitMessage: _vm.sendComment,
          autoFocused: function ($event) {
            _vm.autoFocus = false
          },
        },
      }),
      _vm.responseComment
        ? _c("div", { staticClass: "container-response-comment" }, [
            _c("p", [
              _vm._v("Répondre à "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.getCommentById(_vm.responseComment.split(",").pop())
                      ? _vm.getCommentById(_vm.responseComment.split(",").pop())
                          .user.name
                      : ""
                  )
                ),
              ]),
            ]),
            _c("i", {
              staticClass: "fa-solid fa-circle-xmark",
              on: { click: _vm.stopResponseComment },
            }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container-none-post" }, [
      _c("div", { staticClass: "none-post" }, [
        _c("p", [_vm._v("Post non disponible")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "picture" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "top" }, [
      _c("p", [_vm._v("0 commentaires • 0 republication")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "picture-user" }, [
      _c("img", {
        attrs: {
          src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-content" }, [
      _c("div", { staticClass: "action" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }